var React = require('react');

function CancelInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M14.3958 14.3958L9.60418 9.60417","stroke":"#FF4D6D","strokeWidth":"1.25","strokeLinecap":"round","key":0}),React.createElement("path",{"d":"M9.60415 14.3958L14.3958 9.60417","stroke":"#FF4D6D","strokeWidth":"1.25","strokeLinecap":"round","key":1}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7.20833 16.7918C9.85469 19.4381 14.1453 19.4381 16.7917 16.7918C19.438 14.1454 19.438 9.85479 16.7917 7.20842C14.1453 4.56205 9.85469 4.56205 7.20833 7.20842C4.56196 9.85479 4.56196 14.1454 7.20833 16.7918Z","stroke":"#FF4D6D","strokeWidth":"1.25","key":2})]);
}

CancelInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = CancelInline;

CancelInline.default = CancelInline;
